// extracted by mini-css-extract-plugin
export default {"editMode":"Vendors_editMode__rRNmV","readonlyMode":"Vendors_readonlyMode__GMR+G"};